import React from 'react';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  onSubmit,
  submitText = "Guardar",
  cancelText = "Cancelar",
  hideCancel = false,
  hideSubmit = false,
  submitButtonClass = "btn-primary",
  size = "default"
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    small: "max-w-md",
    default: "max-w-4xl",
    large: "max-w-6xl"
  };

  return (
    <div className="modal-overlay">
      <div className={`modal-content-improved ${sizeClasses[size]}`}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button onClick={onClose} className="modal-close">×</button>
        </div>
        
        <form onSubmit={onSubmit} className="modal-body">
          {children}
          
          <div className="modal-footer">
            {!hideCancel && (
              <button
                type="button"
                onClick={onClose}
                className="btn btn-outline"
              >
                {cancelText}
              </button>
            )}
            {!hideSubmit && (
              <button
                type="submit"
                className={`btn ${submitButtonClass}`}
              >
                {submitText}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

// Componente para el grid de dos columnas del formulario
const ModalFormGrid = ({ children }) => (
  <div className="modal-form-grid">
    {children}
  </div>
);

// Componente para cada columna del formulario
const ModalFormColumn = ({ children }) => (
  <div className="modal-form-column">
    {children}
  </div>
);

// Componente para grupos de campos
const FormGroup = ({ label, required = false, children, htmlFor }) => (
  <div className="form-group">
    {label && (
      <label htmlFor={htmlFor} className="form-label">
        <span className="label-text">{label}</span>
        {required && <span className="label-required">*</span>}
      </label>
    )}
    {children}
  </div>
);

export default Modal;
export { ModalFormGrid, ModalFormColumn, FormGroup }; 